module.exports = __webpack_public_path__ + "static/media/youtube.ef57d5a0.jpg";